/**
 * [INPUT]: 依赖 react-markdown、GFM 扩展、rehype 消毒器与运营输入的 Markdown
 * [OUTPUT]: 对外提供与玩家侧同规则的安全 AnnouncementMarkdown 预览组件
 * [POS]: admin-web 公告内容预览边界，禁用原始 HTML/图片并仅放行 HTTP(S) 外链
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
import { ExternalLink } from 'lucide-react';
import { cn } from '../lib/utils';

export function safeAnnouncementLink(href?: string): string | null {
  if (!href) return null;
  try {
    const parsed = new URL(href);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.toString() : null;
  } catch {
    return null;
  }
}
export function AnnouncementMarkdown({ body, className }: { body: string; className?: string }) {
  return (
    <div className={cn('admin-announcement-prose', className)}>
      <ReactMarkdown
        components={{
          a: ({ children, href, title }) => {
            const safeHref = safeAnnouncementLink(href);
            return safeHref ? <a href={safeHref} rel="noreferrer noopener" target="_blank" title={title}>{children}<ExternalLink aria-hidden="true" className="inline h-3 w-3" /></a> : <span>{children}</span>;
          },
          img: () => null,
        }}
        rehypePlugins={[rehypeSanitize]}
        remarkPlugins={[remarkGfm]}
        skipHtml
      >
        {body}
      </ReactMarkdown>
    </div>
  );
}
